
import { Options, Vue } from "vue-class-component";
import { PropType, ref } from "vue";
import OverlayPanel from "primevue/overlaypanel";
import { createFocusTrap } from 'focus-trap';


@Options({
  components: {
    OverlayPanel
  },
  props: {
    menus: {
      default: [],
      type: Array
    },
    action: {
      default: Function as PropType<() => number>,
      type: Function
    },
    isDisabled: {
      default: false,
      type: Boolean
    },
    isBottom: {
      default: false,
      type: Boolean
    },
    isPrintAble: {
      default: false,
      type: Boolean
    },
    triggerFocus: {
      default: false,
      type: Boolean
    }
  },

  directives: {
    "click-outside": {
      beforeMount: (el: any, binding: any) => {
        const ourClickEventHandler = (event: any) => {
          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event);
          }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;
        document.addEventListener("click", ourClickEventHandler);
      },
      unmounted: (el: any) => {
        document.removeEventListener("click", el.__vueClickEventHandler__);
      }
    }
  }
})
export default class Book extends Vue {
  props: any = this.$props;
  isShow = false;
  menuRefs: any = [];
  currentIndex = 0;
  isMouseDown = false;
  focusTrap: any = null;

  showDownloadChoice() {
    this.isShow = !this.isShow;
  }
  toggleTooltip(event: any) {
    this.showDownloadChoice();
    const refs: any = this.$refs;
    refs["opTooltip"].toggle(event);

    if (this.props.triggerFocus) {
      this.$nextTick(() => {
        if (this.isShow) {
          // const menuref = this.$refs["menuRefs-0"] as any
          // menuref?.focus();
          if (!this.$refs.listContainer) return
          this.focusTrap = createFocusTrap(this.$refs.listContainer as any, {
            allowOutsideClick: true,
            escapeDeactivates: true,
            returnFocusOnDeactivate: false,
            onDeactivate: () => {
              this.focusTrap = null;
              this.isShow = false;
            }
          })
          this.focusTrap.activate();
        }
      })
    }
  }

  hideToggle(event: any) {
    const refs: any = this.$refs;
    refs["opTooltip"].hide(event);
    this.isShow = !this.isShow;
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
  }

  onCloseAnywhere(value: boolean) {
    this.isShow = value;
  }

  onFocusButton(event: any) {
    if (this.props.triggerFocus && !this.isMouseDown) {
      this.toggleTooltip(event);
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === "Enter") {
      this.props.action(index);
      this.hideToggle(event);
      event.preventDefault();
      return;
    }
    if (event.key === "Tab" && event.shiftKey) {
      if (this.focusTrap) this.focusTrap.deactivate();
      this.currentIndex = 0;
      (this.$refs as any)[`menuRefs-${this.currentIndex}`]?.focus();
      setTimeout(() => {
        this.$nextTick().then(() => {
          const button = this.$refs['button-list'] as any;
          const all = Array.from(
            document.querySelectorAll(
              'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )
          ).filter((el: any) => !el.disabled && el.offsetParent !== null) as any;
          const index = all.findIndex((el: any) => button.contains(el))
          const prev = all[index - 1];
          if (prev) {
            const refs: any = this.$refs;
            refs["opTooltip"].hide(event);
            this.$nextTick().then(() => {
              this.isShow = false;
              prev.focus();
            })
          }
        });
      }, 100)
      return;
    }

    if (event.key === "Escape") {
      this.currentIndex = 0;
      (this.$refs as any)[`menuRefs-${this.currentIndex}`]?.focus();
      setTimeout(() => {
        this.hideToggle(event)
      }, 50);
    } else if (event.key === "ArrowDown" || event.key === "Tab") {
      event.preventDefault();
      const nextIndex = (this.currentIndex + 1) % this.props.menus.length;
      (this.$refs as any)[`menuRefs-${nextIndex}`]?.focus();
      this.currentIndex = nextIndex;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevIndex = (this.currentIndex - 1 + this.props.menus.length) % this.props.menus.length;
      (this.$refs as any)[`menuRefs-${prevIndex}`]?.focus();
      this.currentIndex = prevIndex;
    } else if (event.key === " ") {
      setTimeout(() => {
        this.props.action(this.currentIndex);
        this.hideToggle(event);
      }, 50);
    }
  }
}
